import { useState, useContext } from "react"
// my imports:
import OneOffHint from "@/app/components/OneOffHint"
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";

export default function RecipeTitle() {
    
    const ui: UI | null = useContext(Contexts.UI);
    if (!ui) {
        console.warn("bad context in RecipeTitle component");
        return null;
    }
    
    const element = ui.letterRefs.current?.[4]?.[2] ?? null;

    const [isShowingHint, setIsShowingHint] = useState(false);

    function toggleHint() {
        setIsShowingHint(!isShowingHint);
    }

    const hintText: string = `These rows of boxes are "recipes," or partially filled-in words. The green letters don't change. Fill in empty boxes using the ingredients.`

    return(
        <>
        {isShowingHint && element !== null &&
            <OneOffHint
                element={element}
                text={hintText}
                linkText="Dismiss"
                setShowing={setIsShowingHint}
            />
        }
        <div
            tabIndex={0}
            onClick={(e) => {
                e.stopPropagation();
                toggleHint();
            }}
            onBlur={() => setIsShowingHint(false)}
        >
            <h2 className='title textAsButton'>
                recipes:
            </h2>
        </div>
        </>
    )
}